// Events
import {
  COLLECTION_ACTIVATE_BACK_TO_TOP,
  COLLECTION_DEACTIVATE_BACK_TO_TOP,
  COLLECTION_RUN_BACK_TO_TOP,
} from 'events';
import { component } from 'picoapp';

export default component(async (node, ctx) => {
  ctx.on(COLLECTION_RUN_BACK_TO_TOP, () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  });

  ctx.on(COLLECTION_ACTIVATE_BACK_TO_TOP, () => {
    node.classList.add('show');
  });

  ctx.on(COLLECTION_DEACTIVATE_BACK_TO_TOP, () => {
    node.classList.remove('show');
  });

  node.addEventListener('click', () => {
    ctx.emit(COLLECTION_RUN_BACK_TO_TOP);
  });
});
